module.exports = __webpack_public_path__ + "static/media/logo.456dd76b.png";